import { Country } from '@/models/country';
import type { AiModelContent } from '../aiLeagueTypes';
import placeholderImage from '@/assets/ai-league/placeholder.svg';

export const DEEPSEEK_AI_CONTENT: AiModelContent = {
  id: 'deepseek',
  tabLabel: 'DeepSeek',
  displayName: 'DeepSeek',
  countryList: [
    Country.FR,
    Country.ES,
    Country.BR,
    Country.GB_ENG,
    Country.UY,
    Country.CO,
    Country.MA,
    Country.JP,
    Country.SE,
    Country.TR,
  ],
  listValid: true,
  responseTimeSeconds: 45,
  imageSrc: placeholderImage,
  justificationText: `Explanation:

I maximised expected total points by ranking teams according to projected raw points (goals, wins, progression) multiplied by the descending multipliers. France are my top pick due to their deep squad, Mbappé, and consistent tournament performance; they have the highest likelihood of reaching the final and accumulating ~55 raw points. Spain, as reigning European champions with a young core, closely follow. Brazil and England round out the four permitted Seeds, all with strong knockout-stage expectations. For Intermediates, I selected Uruguay, Colombia, Morocco, and Japan – all possess the quality to reach the Round of 16 or beyond, generating solid returns without wasting high multipliers. The two required Outsiders, Sweden and Türkiye, are the strongest available in that category (featuring elite players like Isak, Kulusevski, Çalhanoğlu) and can deliver group-stage wins and a potential Round of 32 appearance, earning around 15–18 raw points each. The biggest risk is England’s historical underperformance: if they fail to advance past the quarter-finals, their x7 multiplier slot will underachieve relative to an alternative high-ceiling Intermediate like Senegal or Croatia.`,
};
